module.exports = __webpack_public_path__ + "static/media/profileActive.3d88dc34.svg";